import { findBoilerAdapterBySlot, getHeatingCircuitByType } from 'z3k-parser/lib';
import { BoilerAdapter, BoilerCascade, HeatingCircuit, IOExtension } from 'z3k-config';
import { boiler_id_2_adapter_slot } from 'console/climatic/constants';
import { guess_boiler_control_type } from 'console/climatic/setting-tabs/configuration';
import { BoilerControlType, } from 'console/climatic/setting-tabs/type';
import { useContext } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function useBoilersState() {
    const { deviceFirmwareVersion } = useContext(Z3KSettings);
    const { config, validation_result } = useContext(Z3KSettingsEditor);
    const state = {
        firmware_version: deviceFirmwareVersion,
        boilers: getHeatingCircuitByType(config, HeatingCircuit.Type.BOILER).map((circuit) => {
            const adapter = BoilerAdapter.get.one(config, (adapter) => adapter.slot == boiler_id_2_adapter_slot(circuit.id));
            return {
                id: circuit.id,
                name: circuit.name,
                min_temperature: typeof circuit.water_min_temperature === 'string'
                    ? +circuit.water_min_temperature
                    : circuit.water_min_temperature,
                max_temperature: typeof circuit.water_max_temperature === 'string'
                    ? +circuit.water_max_temperature
                    : circuit.water_max_temperature,
                hysteresis: circuit.hysteresis,
                has_boiler_adapter: adapter != null,
                corresponding_adapter: {
                    id: adapter?.id,
                    type: adapter?.type,
                    boiler_model: adapter?.boiler_model,
                    max_modulation_level: adapter?.max_modulation_level,
                    serial: adapter?.serial,
                    logged_parameter_register: adapter?.logged_parameter_register,
                    processor: adapter?.processor,
                    hardware: adapter?.hardware,
                    adapter_type: adapter?.adapter_type,
                },
                builtin_io_extensions_versions: IOExtension.get
                    .where(config, IOExtension.isBuiltIn)
                    .map((io_ext) => {
                    const { fw, hw } = IOExtension.getHardwareAndSoftwareVersion(io_ext);
                    return [hw, fw];
                }),
            };
        }),
        cascades: BoilerCascade.get.all(config).map((cascade) => ({
            id: cascade.id,
            name: cascade.name,
            lead_boiler_switch_delay: cascade.lead_boiler_switch_delay,
            rotation_period: cascade.rotation_period,
            slave_boiler_start_delay: cascade.slave_boiler_start_delay,
            slave_boiler_finish_delay: cascade.slave_boiler_finish_delay,
            hysteresis: cascade.hysteresis,
            setting_register: cascade.setting_register,
        })),
    };
    const configuration = {
        boilers: getHeatingCircuitByType(config, HeatingCircuit.Type.BOILER).map((circuit) => {
            const control_type = guess_boiler_control_type(config, circuit);
            const slot = boiler_id_2_adapter_slot(circuit.id);
            const boiler_adapter = slot != null ? findBoilerAdapterBySlot(config, slot) : null;
            return {
                id: circuit.id,
                name: circuit.name,
                control_type,
                has_adapter_on_slot: slot != null && boiler_adapter != null,
                show_unknown_option: control_type == BoilerControlType.UNKNOWN,
            };
        }),
    };
    const enabled_boilers = state.boilers
        .map((boiler, i) => [
        boiler,
        i,
        configuration.boilers.find((bs) => bs.id == boiler.id),
    ])
        .filter(([, , boiler_configuration]) => boiler_configuration.control_type != BoilerControlType.OFF);
    return { state, configuration, enabled_boilers };
}
